import { createContext } from 'react';
export var ManyToManyReferenceContext = createContext(undefined);
